import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import addPlus from '@/utilities/addPlus';
import { startCase } from 'lodash';
import ProficiencyDots from '@/components/ProficiencyDots.vue';
import CharacterSheetTweaker from './CharacterSheetTweaker.vue';
let CharacterSheetAbilities = class CharacterSheetAbilities extends Vue {
    constructor() {
        super(...arguments);
        this.addPlus = addPlus;
        this.startCase = startCase;
    }
};
__decorate([
    Prop(Object)
], CharacterSheetAbilities.prototype, "abilityScores", void 0);
__decorate([
    Prop(Object)
], CharacterSheetAbilities.prototype, "tweaks", void 0);
CharacterSheetAbilities = __decorate([
    Component({
        components: {
            CharacterSheetTweaker,
            ProficiencyDots
        }
    })
], CharacterSheetAbilities);
export default CharacterSheetAbilities;
